import { createContext, useContext } from 'react'

const DevModeContext = createContext<boolean>(false)

export const DevModeProvider = DevModeContext.Provider

export function useDevMode() {
  return useContext(DevModeContext)
}
